import React, { PureComponent } from "react";
import IssuesContainer from "./Containers/IssuesContainer";

class IssuesPage extends PureComponent {
  render() {
    return (
      <div>
        <IssuesContainer
          names={this.props.location.search}
          id={this.props.match.params.id}
        />
      </div>
    );
  }
}

export default IssuesPage;
